import React from "react";
import PropTypes from "prop-types";

export default class ErrorBoundary extends React.Component {
  static propTypes = {
    sectionName: PropTypes.string,
    children: PropTypes.node
  };

  static defaultProps = {
    sectionName: null
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Marca que ocurrió un error y almacena el objeto
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Guarda también la traza de componentes
    this.setState({ errorInfo });
    // Aquí podrías enviar error + errorInfo a un sistema de logging externo
    console.error("Error capturado por ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const { error, errorInfo } = this.state;
      const { sectionName } = this.props;
      return (
        <div style={{ padding: 20, background: "#fee", color: "#900" }}>
          {/* Sección opcional para identificar en qué parte ocurrió */}
          {sectionName && <h4>Error en sección: {sectionName}</h4>}

          <h2>¡Lo sentimos! Algo salió mal.</h2>
          <h2>Sorry! Something went wrong.</h2>

          <h3>Mensaje de error / Error message:</h3>
          <pre style={{ whiteSpace: "pre-wrap" }}>{error?.toString()}</pre>

          <h3>Stack completo / Full stack trace:</h3>
          <pre style={{ whiteSpace: "pre-wrap", fontSize: 12, marginTop: 10 }}>
            {error?.stack || (errorInfo && errorInfo.componentStack)}
          </pre>
        </div>
      );
    }

    return this.props.children;
  }
}
